export const managePageNumber = () => {
  let pageNumberCount = 1;

  const incrementPage = () => {
    pageNumberCount += 1;
    return pageNumberCount;
  };

  const resetPage = () => {
    pageNumberCount = 1;
    return pageNumberCount;
  };

  const getPage = () => pageNumberCount;

  return {
    incrementPage,
    resetPage,
    getPage,
  };
};
